import { combineReducers } from 'redux'
import * as types from './types'

const cities = (state = {}, { type, meta, payload }) => {
  const { countryId, regionId, start } = meta || {}

  switch (type) {
    case types.FETCH_CITIES_SUCCESS:
      return { ...state, [countryId + (regionId ? `.${regionId}` : '')]: payload.data }

    case types.SEARCH_CITIES_SUCCESS:
      return { ...state, [`${countryId}.${start}`]: payload.data }

    default:
      return state
  }
}

const regions = (state = {}, { type, meta, payload }) => {
  switch (type) {
    case types.FETCH_REGIONS_SUCCESS:
      return { ...state, [meta.countryId]: payload.data }

    default:
      return state
  }
}

export default combineReducers({ cities, regions })
